import { appContextConstants } from '../constants/appContext.constants';

const initialState = {
  // Application context
  userId: null,
  selectedUserId: null,
  appId: null,
  applicationId: null,
  coapplicantId: null,
  coappId: null,
  status: null,
  // Loan context
  loanId: null,
  loanid: null,
  legacyLoanId: null,
  finstaId: null,
  // Regen/modal context
  regenAppId: null,
  regenUserId: null,
  regenName: null,
  mStatus: null,
  // Activity context
  activityAppId: null,
  activityUserId: null,
  activityAppLoanId: null,
  activityAppLegacyLoanId: null,
  // Repayments context
  repaymentsUserId: null,
  repaymentsAppId: null,
  // Refetch context
  refetchUid: null,
  refetchAppId: null,
  // Complex data
  foirData: null,
};

export function appContext(state = initialState, action) {
  switch (action.type) {
    case appContextConstants.SET_APP_CONTEXT:
    case appContextConstants.SET_LOAN_CONTEXT:
    case appContextConstants.SET_REGEN_CONTEXT:
    case appContextConstants.SET_ACTIVITY_CONTEXT:
    case appContextConstants.SET_REPAYMENTS_CONTEXT:
    case appContextConstants.SET_REFETCH_CONTEXT:
      return { ...state, ...action.payload };
    case appContextConstants.SET_FOIR_DATA:
      return { ...state, foirData: action.payload };
    case appContextConstants.CLEAR_APP_CONTEXT:
      return initialState;
    default:
      return state;
  }
}
